import {
  UilArrowFromRight,
  UilLeftArrowToLeft,
} from "@iconscout/react-unicons";
import Button from "components/base/Button";
import { capitalize } from "helpers/utils";
import { useAppContext } from "providers/AppProvider";
import { useBreakpoints } from "providers/BreakpointsProvider";
import { Nav, Navbar, Placeholder } from "react-bootstrap";
import { useDynamicSitemap } from "hooks/useDynamicSitemap";
import NavbarTopNav from "../navbar-horizontal/NavbarTopNav";
import NavbarVerticalCollapseProvider from "./NavbarVerticalCollapseProvider";
import NavbarVerticalMenu from "./NavbarVerticalMenu";
import EmpresaSelector from "components/empresa/EmpresaSelector";

const NavbarVerical = () => {
  const {
    config: {
      navbarPosition,
      openNavbarVertical,
      navbarVerticalAppearance,
      isNavbarVerticalCollapsed,
    },
    setConfig,
  } = useAppContext();

  const { breakpoints } = useBreakpoints();

  const { routes: menuRoutes, isLoading: isLoadingMenu } = useDynamicSitemap();


  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className="navbar-vertical"
        expand="lg"
        variant=""
        data-navbar-appearance={
          navbarVerticalAppearance === "darker" ? "darker" : ""
        }
      >
        <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
          <div className="navbar-vertical-content">
            <div className="p-2">
              {openNavbarVertical && <EmpresaSelector />}
            </div>
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">
              {isLoadingMenu && menuRoutes.length === 0
                ? Array.from({ length: 5 }).map((_, secao) => (
                    <Nav.Item key={`sk-${secao}`} className="px-3 mb-3">
                      <Placeholder animation="wave" as="div" className="mb-2">
                        <Placeholder xs={5} bg="secondary" style={{ height: 10 }} />
                      </Placeholder>
                      {Array.from({ length: 3 }).map((__, item) => (
                        <Placeholder
                          key={`sk-${secao}-${item}`}
                          animation="wave"
                          as="div"
                          className="mb-2"
                        >
                          <Placeholder xs={9} style={{ height: 14 }} />
                        </Placeholder>
                      ))}
                    </Nav.Item>
                  ))
                : null}
              {menuRoutes.map((route) => (
                <Nav.Item key={route.label}>
                  {!route.labelDisabled && (
                    <>
                      <p className="navbar-vertical-label">
                        {capitalize(route.label)}
                      </p>
                      <hr className="navbar-vertical-line" />
                    </>
                  )}
                  <NavbarVerticalMenu level={1} routes={route.pages} />
                </Nav.Item>
              ))}
            </Nav>

            {navbarPosition === "combo" && breakpoints.down("lg") && (
              <div className="move-container">
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr" />
                </div>
                <NavbarTopNav />
              </div>
            )}
          </div>
        </Navbar.Collapse>
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed,
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <UilArrowFromRight size={16} className="mb-1" />
            ) : (
              <>
                <UilLeftArrowToLeft size={16} className="mb-1" />
                <span className="ms-2">Minimizar</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVerical;
